import { render, staticRenderFns } from "./LayoutA.vue?vue&type=template&id=0495dfdc&scoped=true"
import script from "./LayoutA.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutA.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LayoutA.vue?vue&type=style&index=0&id=0495dfdc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0495dfdc",
  null
  
)

export default component.exports